export default class NumberUtils {
  public static hasDecimals = (n: number) => {
    return n % 1 !== 0;
  };
}
